import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';

import { inviteUserModalSlice, InviteUserModalState } from '@REDUCERS';

function createInviteUserModalHook() {
    return function useInviteUserModal(equalityFn?: EqualityFn<InviteUserModalState>) {
        const state = useAppSelector((store) => store.inviteUserModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: () => dispatch(inviteUserModalSlice.actions.open()),
            close: () => dispatch(inviteUserModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createInviteUserModalHook(); 